'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasMessages = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _threadHistoryInvariant = require('../../invariants/threadHistoryInvariant');

var _getters = require('./getters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * True if a ThreadHistory has messages in it
 * 
 * @param {ThreadHistory} threadHistory 
 * @returns {Boolean}
 */
var hasMessages = exports.hasMessages = function hasMessages(threadHistory) {
  (0, _threadHistoryInvariant.threadHistoryInvariant)(threadHistory);

  return (0, _pipe2.default)(_getters.getMessages, function (messages) {
    return !!(messages && messages.size > 0);
  })(threadHistory);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/operators/hasMessages.js
// module id = 35
// module chunks = 2 3